var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-account-type",class:_vm.clazz},[_c('i',{staticClass:"banana banana-check-normal",attrs:{"aria-hidden":"true"}}),_vm._t("cardImg"),_c('h2',{staticClass:"title",class:_vm.clazzTitle},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.titleStrong)?_c('strong',[_vm._v(_vm._s(_vm.titleStrong))]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }